import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessProviderId } from '@fgb/core';

class LoyaltyIconComponent {
    constructor() {
        this.gIconAuction = 'gavel';
        this.gIconLotto = 'confirmation_number';
        this.gIconMarketplace = 'shopping_bag';
        this.gIconWallet = 'account_balance_wallet';
        this.gIconWalletRedeemed = 'shopping_bag';
        this.gIconMarketplaceFortressGb = 'shopping_bag';
        this.gIconMarketplaceUniqueCode = 'qr_code';
        this.gIconMarketplaceDownload = 'file_download';
        this.gIconMarketplaceEvent = 'local_activity';
        this.gIconMarketplacePortalProduct = 'redeem';
        this.gIconMarketplaceVirtualEvent = 'local_activity';
    }
    ngOnInit() {
        switch (this.loyaltyType) {
            case 'auction':
                this.gIcon = this.gIconAuction;
                break;
            case 'lotto':
                this.gIcon = this.gIconLotto;
                break;
            case 'wallet':
                this.gIcon = this.gIconWallet;
                break;
            case 'walletRedeemed':
                this.gIcon = this.gIconWalletRedeemed;
                break;
            case ProcessProviderId.FortressGB:
                this.gIcon = this.gIconMarketplaceFortressGb;
                break;
            case ProcessProviderId.UniqueCode:
                this.gIcon = this.gIconMarketplaceUniqueCode;
                break;
            case ProcessProviderId.Download:
                this.gIcon = this.gIconMarketplaceDownload;
                break;
            case ProcessProviderId.Event:
                this.gIcon = this.gIconMarketplaceEvent;
                break;
            case ProcessProviderId.Product:
                this.gIcon = this.gIconMarketplacePortalProduct;
                break;
            case ProcessProviderId.VirtualEvent:
                this.gIcon = this.gIconMarketplaceVirtualEvent;
                break;
            default:
                this.gIcon = this.gIconMarketplace;
                break;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: LoyaltyIconComponent, selector: "fgbcl-loyalty-icon", inputs: { loyaltyType: "loyaltyType" }, ngImport: i0, template: "<span class=\"icon material-icons\" aria-hidden=\"true\">{{ gIcon }}</span>\r\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-loyalty-icon', template: "<span class=\"icon material-icons\" aria-hidden=\"true\">{{ gIcon }}</span>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { loyaltyType: [{
                type: Input
            }] } });

class LoyaltyIconModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconModule, declarations: [LoyaltyIconComponent], imports: [CommonModule], exports: [LoyaltyIconComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: LoyaltyIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoyaltyIconComponent],
                    imports: [CommonModule],
                    exports: [LoyaltyIconComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LoyaltyIconComponent, LoyaltyIconModule };
